import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import Dashboard from "../components/MerchantDashboard";
import CustomHelmet from "../components/CustomHelmet";
import analytics from "../images/analytics.png";
import ratingImg from "../images/rating.png";
import reviewImg from "../images/reviews.png";
import { Link } from "react-router-dom";
import axios from "axios";

const url =
  "https://www.hubsquares.com/php_files/fetchListingOwner.php/";
const urlReview =
  "https://www.hubsquares.com/php_files/fetchReview.php/";
const DashboardHome = (props) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [analytic, setAnalytic] = useState("");
  useEffect(() => {
    const fetchListing = async () => {
      await axios.post(url, { owner: props.user }).then((res) => {
        if (res.data.listing) {
          setAnalytic(res.data.listing[0].counter);
          axios
            .post(urlReview, { refID: res.data.listing[0].refID })
            .then((res) => setListings(res.data.reviews));
          setLoading(false);
        } else setLoading(false);
      });
    };
    fetchListing();
  }, [props.user]);
  return (
    <>
      <CustomHelmet page="Dashboard" />
      <Dashboard user={props.user} page="Dashboard">
        <Container className="my-3" style={{ minHeight: "60vh" }}>
          <h4 className="mt-3">Welcome to your hub {props.user}</h4>
          {loading ? (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : (
            <Row className="my-3">
              <Col className="mb-3" md={4}>
                <Card>
                  <Card.Img
                    style={{ height: 120, width: 120, margin: "8px auto" }}
                    variant="top"
                    src={analytics}
                  />
                  <Card.Body>
                    <Card.Title>
                      Business Views: {analytic ? analytic : "nil"}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4} className="mb-3">
                <Card>
                  <Card.Img
                    style={{ height: 120, width: 120, margin: "8px auto" }}
                    variant="top"
                    src={ratingImg}
                  />
                  <Card.Body>
                    <Card.Title>
                      Business Rating:{" "}
                      {listings && listings.length >= 1
                        ? listings[0].rating_percent
                        : 0}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} className="mb-3">
                <Link to="/reviews" className="text-decoration-none text-dark">
                  <Card className="hover-border-dark">
                    <Card.Img
                      style={{ height: 120, width: 120, margin: "8px auto" }}
                      variant="top"
                      src={reviewImg}
                    />
                    <Card.Body>
                      <Card.Title>
                        Reviews: {listings ? listings.length : "0"}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            </Row>
          )}
        </Container>
      </Dashboard>
    </>
  );
};
export default DashboardHome;
